import { Collections } from "@mui/icons-material";
import React from "react";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

export const OneLayout = ({ image }) => {
  return (
    <div className="">
      {" "}
      <Zoom>
        <div className="h-[376px] flex gap-3 p-4">
          <div className="flex-1">
            <div className="rounded-lg border border-[#E1E6E1] h-full bg-[#D9D9D9]">
              <img
                src={image}
                alt="product"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>
        </div>
      </Zoom>
    </div>
  );
};

export const TwoLayout = ({ images }) => {
  return (
    <div className="">
      {" "}
      <div className="h-[400px] flex gap-3 p-4">
        <div className="flex-1">
          <Zoom>
            <div className="rounded-lg border border-[#E1E6E1] h-full bg-[#D9D9D9]">
              <img
                src={images[0]}
                alt="product"
                className="w-full object-cover rounded-lg h-[376px]"
              />
            </div>
          </Zoom>
        </div>
        <div className="flex-1">
          <Zoom>
            <div className="rounded-lg border border-[#E1E6E1] h-full bg-[#D9D9D9]">
              <img
                src={images[1]}
                alt="product"
                className="w-full object-cover rounded-lg h-[376px]"
              />
            </div>
          </Zoom>
        </div>
      </div>
    </div>
  );
};

export const ThreeLayout = ({ images }) => {
  return (
    <div className="">
      {" "}
      <div className="h-[400px] flex gap-3 p-4">
        <div className="flex-1">
          <Zoom>
            <div className="rounded-lg border border-[#E1E6E1] h-full bg-[#D9D9D9]">
              <img
                src={images[0]}
                alt="product"
                className="w-full  h-[376px] object-cover rounded-lg"
              />
            </div>
          </Zoom>
        </div>
        <div className="flex-1">
          <Zoom>
            <div className="rounded-lg border border-[#E1E6E1] h-full bg-[#D9D9D9]">
              <img
                src={images[1]}
                alt="product"
                className="w-full  h-[376px]object-cover rounded-lg"
              />
            </div>
          </Zoom>
        </div>

        <div className="flex-1">
          <Zoom>
            <div className="rounded-lg border border-[#E1E6E1] h-full bg-[#D9D9D9]">
              <img
                src={images[2]}
                alt="product"
                className="w-full h-[376px] object-cover rounded-lg"
              />
            </div>
          </Zoom>
        </div>
      </div>
    </div>
  );
};

export const FourLayout = ({ images }) => {
  return (
    <div className="relative">
      {" "}
      <div className="h-[400px] flex gap-3 p-4">
        <div className="flex-1">
          <Zoom>
            <div className="rounded-lg border border-[#E1E6E1] h-full bg-[#D9D9D9]">
              <img
                src={images[0]}
                alt="product"
                className="w-full h-[376px] object-cover rounded-lg"
              />
            </div>
          </Zoom>
        </div>
        <div className="flex-1">
          {" "}
          <Zoom>
            <div className="rounded-lg border border-[#E1E6E1] h-full bg-[#D9D9D9]">
              <img
                src={images[1]}
                alt="product"
                className="w-full h-[376px] object-cover rounded-lg"
              />
            </div>
          </Zoom>
        </div>
        <div className="flex-1">
          {" "}
          <div className=" h-full flex flex-col gap-3 ">
            <div className="flex-1 h-1/2">
              {" "}
              <Zoom>
                <div className="rounded-lg border border-[#E1E6E1] h-full bg-[#D9D9D9]">
                  <img
                    src={images[2]}
                    alt="product"
                    className="w-full h-[180px] object-cover rounded-lg"
                  />
                </div>
              </Zoom>
            </div>
            <div className="flex-1 h-1/2">
              {" "}
              <Zoom>
                <div className="rounded-lg border border-[#E1E6E1] h-full bg-[#D9D9D9]">
                  <img
                    src={images[3]}
                    alt="product"
                    className="w-full h-[180px] object-cover rounded-lg"
                  />
                </div>
              </Zoom>
            </div>
          </div>
        </div>
      </div>
      {images?.length > 4 && (
        <div className="absolute right-3.5 bottom-4 rounded-lg flex gap-2 justify-center items-center py-1 bg-[#181B1929] px-2 h-[34px]">
          <Collections style={{ color: "#FFF", fontSize: "16px" }} />
          <p className="text-white text-sm font-semibold shadow-[34px] ">
            {images?.length} Photos
          </p>
        </div>
      )}
    </div>
  );
};
